// extracted by mini-css-extract-plugin
module.exports = {"flexShrinkWrapper":"_10218"};